exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.post-intro[data-v-070354f6]::after {\n  content: '';\n  background: #fff;\n  height: 1px;\n  width: 500px;\n  min-width: 95%;\n  position: absolute;\n  top: 4rem;\n  right: 0;\n}\n@media screen and (max-width: 1024px) {\n.post-intro[data-v-070354f6]::after {\n    display: none;\n}\n}\n", ""]);

// exports
